<template>
    <div>
        <b-modal id="man-allowance-upload" title="Excel Yükle" scrollable no-close-on-esc no-close-on-backdrop>
            <man-allowance-upload v-model="uploadObject"></man-allowance-upload>
            <template #modal-footer><v-executer :loading="uploading" :action="upload">Yükle</v-executer></template>
        </b-modal>

        <b-card no-body class="p-1 mb-1">
            <div class="row align-items-center">
                <div class="col-md-2 mb-1 mb-md-0">
                    <label class="form-label">Ay</label>
                    <select class="form-control bg-img-none" v-model="donem.month">
                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                    </select>
                </div>
                <div class="col-md-2 mb-1 mb-md-0">
                    <label class="form-label">Yıl</label>
                    <select class="form-control bg-img-none" v-model="donem.year">
                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                    </select>
                </div>
                <div class="col-md-5 mb-1 mb-md-0">
                    <label class="form-label">Maaş Grubu <span class="text-danger">*</span></label>
                    <v-select-list :options="employeeSalaryGroups" label="Value" v-model="employeeSalaryGroupId" placeholder="Maaş grubu seçin"></v-select-list>
                </div>
            </div>
        </b-card>

        <b-card no-body class="mb-1">
            <v-table    ref="table"
                        :fields="fields"
                        with-items
                        :items="datas"
                        pagination="client"
                        :settings="false">
                <template #additional-actions>
                    <div class="row align-items-center">
                        <div class="col-md-3 mb-1 mb-md-0">
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text>
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success" v-on:click="getData">Sorgula</button>
                        </div>
                        <div class="col-md-auto ml-auto">
                            <b-dropdown text="İşlemler" right variant="primary">
                                <b-dropdown-item v-on:click="uploadExcel">Excel Yükle</b-dropdown-item>
                                <b-dropdown-item v-if="excelPath" v-on:click="downloadExcel">
                                    <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                    Excel İndir
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </template>
            </v-table>
        </b-card>
    </div>
</template>

<script>
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'
import { BCard, BInputGroup, BInputGroupText, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue';
import ManAllowanceUpload from './components/ManAllowanceUpload.vue';
import Additional from '@/utilities/additional'

export default {
    components: {
        BCard,
        ManAllowanceUpload,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        BDropdown,
        BDropdownItem
    },
    data() {
        return {
            searchValue: '',
            excelPath: null,
            datas: [],
            employeeSalaryGroups: [],
            employeeSalaryGroupId: null,
            donem: {
                year: moment().year(),
                month: moment().month() + 1
            },
            months: [
                { index: 1, name: 'Ocak' }, { index: 2, name: 'Şubat' }, { index: 3, name: 'Mart' },
                { index: 4, name: 'Nisan' }, { index: 5, name: 'Mayıs' }, { index: 6, name: 'Haziran' },
                { index: 7, name: 'Temmuz' }, { index: 8, name: 'Ağustos' }, { index: 9, name: 'Eylül' },
                { index: 10, name: 'Ekim' }, { index: 11, name: 'Kasım' }, { index: 12, name: 'Aralık' }
            ],
            years: [],
            // Kolon düzeni referans "Ek Hakediş Yükleme Ekranı (Man)" sekmesiyle birebir (11 kolon).
            // Doldurulacak kolonlar (upload'ın okuduğu): FMÜ, FMÜ [Bayram], Yemek, Yol, ODÖ, Açıklama.
            fields: [
                {
                    name: '',
                    children: [
                        { name: 'Sıra', key: 'Order', tdClass: 'text-nowrap text-center' },
                        { name: 'Adı Soyadı', key: 'FullName', tdClass: 'text-nowrap', sticky: true, tooltip: 'Personelin adı soyadı.' },
                        { name: 'TC', key: 'IdentityNumber', tdClass: 'text-nowrap', tooltip: 'Personelin T.C. kimlik numarası. Upload eşleştirme anahtarıdır (TC + seçilen ay/yıl).' },
                        { name: 'Unvan', key: 'GarageOrTitle', tdClass: 'text-nowrap', tooltip: 'Personelin görev/unvanı.' },
                        { name: 'Şube [Fiili]', key: 'ORGANIZASYONEL_SUBEStr', tdClass: 'text-nowrap', tooltip: 'Personelin en güncel organizasyonel (fiili) şubesi.' },
                    ]
                },
                {
                    name: 'Ek Hakediş (Manuel)',
                    thClass: 'bg-light-secondary',
                    children: [
                        { name: 'FMÜ [Fazla Mesai Ücreti]', key: 'MESAI_UCRETIStr', tdClass: 'text-right text-nowrap border-left', thClass: 'vt-th-text-right text-secondary', tooltip: 'Fazla mesai ücreti (manuel girilir).' },
                        { name: 'FMÜ [Bayram] [Fazla Mesai Ücreti Bayram]', key: 'BAYRAM_MESAISIStr', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-secondary', tooltip: 'Bayram/genel tatil fazla mesai ücreti (manuel girilir).' },
                        { name: 'Yemek Ücreti', key: 'YEMEK_UCRETIStr', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-secondary', tooltip: 'Yemek ücreti (manuel girilir).' },
                        { name: 'Yol Ücreti', key: 'YOL_UCRETIStr', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-secondary', tooltip: 'Yol ücreti (manuel girilir).' },
                        { name: 'ODÖ [Olağandışı Ödemeler]', key: 'DIGERStr', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-secondary', tooltip: 'Olağandışı ödemeler. Girildiğinde Açıklama zorunludur.' },
                        { name: 'Açıklama', key: 'DIGERACIKLAMA', tdClass: 'text-nowrap border-right', thClass: 'vt-th-text-right text-secondary', tooltip: 'Olağandışı ödemeler (ODÖ) açıklaması.' },
                    ]
                }
            ],
            uploading: false,
            uploadObject: {
                File: null,
                Month: null,
                Year: null,
                EmployeeSalaryGroupId: null
            }
        }
    },
    computed: {
        filter() {
            return {
                Month: this.donem.month,
                Year: this.donem.year,
                EmployeeSalaryGroupId: this.employeeSalaryGroupId?.Key || null
            }
        }
    },
    mounted() {
        this.configureYears()
        this.getEmployeeSalaryGroups()
    },
    methods: {
        configureYears() {
            let years = []
            let year = moment().add(1, 'year').format('YYYY')
            let firstYear = 2020
            while (firstYear <= year) {
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        getEmployeeSalaryGroups() {
            EmployeeOperationsApi.SalaryGroup.List().then(res => {
                this.employeeSalaryGroups = res.data
            })
        },
        getData() {
            if (!this.employeeSalaryGroupId) {
                this.$result({ data: { Success: false, Message: 'Lütfen bir maaş grubu seçin.' } })
                return
            }
            this.$refs.table.setLoading(true)
            EmployeeOperationsApi.GSalary.ManAllowanceTable({
                ...this.filter,
                PaginateRequest: {
                    QueryParam: this.searchValue
                }
            }).then(res => {
                if (res.data.Success) {
                    this.datas = res.data.Data.Data?.map((d, i) => ({ Order: i + 1, ...d, Errors: (d.Errors || []).join(', ') }))
                    this.excelPath = res.data.Data.ExcelPath
                } else {
                    this.$result(res)
                }
                this.$refs.table.setLoading(false)
            }).catch(err => {
                this.$result(null, err)
                this.$refs.table.setLoading(false)
            })
        },
        downloadExcel() {
            if (this.excelPath) {
                Additional.DownloadTab(this.excelPath)
            }
        },
        uploadExcel() {
            if (!this.employeeSalaryGroupId) {
                this.$result({ data: { Success: false, Message: 'Lütfen indirdiğiniz dosyayla aynı maaş grubunu seçin.' } })
                return
            }
            this.uploadObject.File = null
            this.uploadObject.Month = this.donem.month
            this.uploadObject.Year = this.donem.year
            this.uploadObject.EmployeeSalaryGroupId = this.employeeSalaryGroupId?.Key || null
            this.$showModal('man-allowance-upload')
        },
        async upload() {
            this.uploading = true
            let formData = await Additional.ToFormData(this.uploadObject, ['File'])
            EmployeeOperationsApi.GSalary.UploadManAllowance(formData).then(res => {
                if (res.data.Success) {
                    this.getData()
                    this.$hideModal('man-allowance-upload')
                }
                this.$result(res)
                this.uploading = false
            }).catch(err => {
                this.uploading = false
                this.$result(null, err)
            })
        }
    }
}
</script>
